<template>
  <div class="login-container">
    <div class="login-wrapper">
      <!-- 登录表单卡片 -->
      <div class="login-card">
        <div class="login-header">
          <h2 class="system-title">管理系统登录</h2>
        </div>
        <div class="group" v-if="logintype == 1">
          <div class="form-group">
            <label for="qiyeuser">企业账号</label>
            <input id="qiyeuser" v-model="qiyeuser" type="text" placeholder="请输入用户名" class="form-input"
              autocomplete="username" />
          </div>

          <!-- 密码输入框 -->
          <div class="form-group">
            <label for="password">密码</label>
            <input id="password" v-model="qiyemima" type="password" placeholder="请输入密码" class="form-input"
              autocomplete="current-password" />
          </div>
        </div>

        <div class="group" v-if="logintype == 2">
          <div class="form-group">
            <label for="username">主账号</label>
            <input id="username" v-model="iammainuser" type="text" placeholder="请输入用户名" class="form-input"
              autocomplete="username" />
          </div>

          <div class="form-group">
            <label for="username">子账号</label>
            <input id="username" v-model="iamuser" type="text" placeholder="请输入用户名" class="form-input"
              autocomplete="username" />
          </div>

          <!-- 密码输入框 -->
          <div class="form-group">
            <label for="password">密码</label>
            <input id="password" v-model="iammima" type="password" placeholder="请输入密码" class="form-input"
              autocomplete="current-password" />
          </div>
        </div>



        <!-- 登录按钮 -->
        <button type="button" @click="login()" :disabled="isLoading" class="login-button">
          登录
        </button>
        <div class="tab">
          <div class="p" @click="switch_tab(1)" :style="{color: logintype == 1 ? '#000' :''}">
            企业账号
          </div>
          <div class="p1">
            |
          </div>
          <div class="p" @click="switch_tab(2)" :style="{color: logintype == 2 ? '#000' :''}">
            IAM
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {
    ref
  } from 'vue'
  import {
    ElMessage
  } from 'element-plus'
  import router from '@/router';
  import {
    menulist,iamlogin
  } from '@/api/api';

  // 企业变量
  const qiyeuser = ref()
  const qiyemima = ref()

  // IAM变量
  const iammainuser = ref()
  const iamuser = ref()
  const iammima = ref()

  //登录切换
  const logintype = ref(1)
  const switch_tab = (type) => {
    logintype.value = type
  }

  const getmenu = async () => {
    const res = await menulist()
    if (res.code == 200) {
      localStorage.setItem('menu', JSON.stringify(res.data.list))
    }
  }

  const login = async () => {
    if (logintype.value == 1) {
      ElMessage.info("暂未开放")
    } else if (logintype.value == 2) {
      if (!iammainuser.value) {
        ElMessage.error('主账号名称不能为空！')
        return
      }
      if (!iamuser.value) {
        ElMessage.error('账号名称不能为空！')
        return
      }
      if (!iammima.value) {
        ElMessage.error('密码不能为空！')
        return
      }
      const data = {
        regionName: iammainuser.value,
        name: iamuser.value,
        password: iammima.value,
      }
      const res = await iamlogin(data)
      if (res.code == 200) {
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('user', JSON.stringify(res.data))
        ElMessage({
          message: '登录成功',
          type: 'success',
        })
        // getmenu()
        iammainuser.value = ''
        iamuser.value = ''
        iammima.value = ''
        router.push('/')
      } else {
        ElMessage({
          message: res.message,
          type: res.error
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 登录页面容器
  .login-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
  }

  // 登录页面包装器
  .login-wrapper {
    width: 100%;
    max-width: 400px;
    z-index: 1;
  }

  // 登录卡片
  .login-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    padding: 40px;
    animation: fadeIn 0.5s ease-in-out;
  }

  // 登录头部
  .login-header {
    text-align: center;
    margin-bottom: 30px;
  }

  // 系统标题
  .system-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }


  // 表单组
  .form-group {
    margin-bottom: 20px;
  }

  // 表单标签
  .form-group label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  // 表单输入框
  .form-input {
    width: 100%;
    height: 40px;
    padding: 0 15px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: #667eea;
      box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
    }
  }

  // 表单选项
  .form-options {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
  }

  // 记住密码复选框
  .remember-checkbox {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;
    cursor: pointer;

    input[type="checkbox"] {
      margin-right: 6px;
      cursor: pointer;
    }
  }

  // 登录按钮
  .login-button {
    width: 100%;
    height: 44px;
    font-size: 16px;
    font-weight: 500;
    border: none;
    border-radius: 8px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .tab {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    .p {
      width: 80px;
      text-align: center;
      font-size: 12px;
      line-height: 22px;
      color: #aaa;
      cursor: pointer;
    }

    .p1 {
      font-size: 12px;
    }
  }

  // 淡入动画
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  // 响应式设计
  @media (max-width: 480px) {
    .login-card {
      padding: 25px;
    }

    .system-title {
      font-size: 20px;
    }

    .login-button {
      height: 40px;
      font-size: 14px;
    }
  }
</style>
